// import Combine from '../../../../assets/imgs/icon/combine.svg';
import Median from 'median-js-bridge';
import { useEffect, useState } from 'react';
import QRCode from 'react-qr-code';
import { CardText } from 'reactstrap';
import styled from 'styled-components';

import Star from '../../../../assets/imgs/icon/star.svg';
import StarInactive from '../../../../assets/imgs/icon/star_inactive.svg';
import { Loading } from '../../../../components/Loading';
import { ErrorMessage } from '../../../../GlobalComponents/ErrorMessage';
import { Flex } from '../../../../GlobalComponents/Flex';
import { IconButton } from '../../../../GlobalComponents/IconButton';
import { Modal } from '../../../../GlobalComponents/Modal';
import { useAppDispatch, useAppSelector } from '../../../../reduxstore/hooks';
import { useSetAsPrimaryCardMutation } from '../../../api';
import { setCard } from '../../../state/profileSlice';
import CardControls from '../containers/CardControls';
import ConfirmationModal from './ConfirmationModal';

interface CardModalProps {
	cardNumber: number;
	balance: number;
	isPrimary: boolean;
	primaryCard?: Card | null;
	closeOnClick: () => void;
}

export const NewCardModal = ({
	cardNumber,
	balance,
	isPrimary,
	// primaryCard,
	closeOnClick
}: CardModalProps): JSX.Element => {
	const dispatch = useAppDispatch();
	const userId = useAppSelector(state => state.authReducer.id);
	const [isPrimaryCard, setAsPrimaryCard] = useState<boolean | undefined>(
		isPrimary
	);
	// const [showConfirmationDialog, setConfirmationDialog] =
	// 	useState<boolean>(false);
	const [showSuccessDialog, setSuccessDialog] = useState<boolean>(false);
	const [showErrorDialog, setErrorDialog] = useState<boolean>(false);
	const [setPrimaryCard, { isLoading, isError, error }] =
		useSetAsPrimaryCardMutation();
	// const [combineCard, { isLoading: isCombineLoading }] =
	// 	useCombineCardMutation();

	const togglePrimaryCard = () => {
		setAsPrimaryCard(!isPrimary);
	};

	useEffect(() => {
		Median.screen.setBrightness({
			brightness: '1.0',
			restoreOnNavigation: true
		});

		return () => {
			Median.screen.setBrightness({
				brightness: 'default',
				restoreOnNavigation: false
			});
		};
	}, []);

	const setDefaultCard = (): void => {
		togglePrimaryCard();
		setPrimaryCard({ id: userId, card_number: cardNumber })
			.unwrap()
			.then((response: ProfileResponse) => {
				dispatch(setCard(response.data.profile.cards));
			});
	};

	// const toggleCombineCard = (): void => {
	// 	setConfirmationDialog(!showConfirmationDialog);
	// };

	// const CombineCard = (): void => {
	// 	combineCard({
	// 		card_number: cardNumber,
	// 		primary_card_number: primaryCard?.card_number,
	// 		id: userId
	// 	})
	// 		.unwrap()
	// 		.then((response: ProfileResponse) => {
	// 			setConfirmationDialog(!showConfirmationDialog);
	// 			setSuccessDialog(true);
	// 			dispatch(setCard(response.data.profile.cards));
	// 		})
	// 		.catch(() => {
	// 			setConfirmationDialog(!showConfirmationDialog);
	// 			setErrorDialog(true);
	// 		});
	// };
	return (
		<>
			<Flex
				$flexDirection="column"
				$rowGap="15px"
				$padding="16px 0 20px 0"
			>
				<Flex $flexDirection="column" $rowGap="5px">
					<Flex
						$flexDirection="row"
						$columnGap="5px"
						$placeContent="center space-between"
						$alignItems="center"
					>
						<Text>Card #{cardNumber}</Text>
						<Text>${balance}</Text>
					</Flex>
					<Notes>
						Show this screen to the barista during checkout
					</Notes>
				</Flex>
				<QRContainer>
					<QRCode
						value={cardNumber?.toString() || 'N/A'}
						size={240}
					/>
				</QRContainer>
			</Flex>
			<Flex
				$flexDirection="row"
				$placeContent="center space-between"
				$alignItems="center"
				$width="100%"
				$columnGap="12px"
			>
				<Flex
					$flexDirection="column"
					$placeContent="center flex-start"
					$alignItems="center"
					$rowGap="12px"
					$padding="12px 0"
				>
					<IconButton
						url={isPrimaryCard ? Star : StarInactive}
						alt={'favorite'}
						width={32}
						height={32}
						disabled={isLoading || isPrimaryCard}
						onClick={setDefaultCard}
					></IconButton>
					<CardText>
						{isLoading ? (
							<Loading />
						) : isPrimaryCard ? (
							'Default Card'
						) : (
							'Set as Default'
						)}
					</CardText>

					{isError && <ErrorMessage error={error} />}
				</Flex>
				{/* {!isPrimary && (
					<Flex
						flexDirection="column"
						placeContent="center flex-start"
						alignItems="center"
						rowGap="12px"
						padding="12px 0"
					>
						<IconButton
							url={Combine}
							alt={'Combine'}
							width={32}
							height={32}
							disabled={isLoading}
							onClick={toggleCombineCard}
						></IconButton>
						<CardText>Combine Card</CardText>
					</Flex>
				)} */}
			</Flex>
			{/* <Flex flexDirection="row" placeContent="center" alignItems="center">
				<Button onClick={toggleHandler}>Add Balance</Button>
			</Flex> */}
			<CardControls
				cardNumber={cardNumber}
				balance={balance}
				source="modal"
				closeOnClick={() => closeOnClick()}
				showAddBalance={true}
				showRemoveCard={!isPrimary}
				setLoadingState={() => {
					return null;
				}}
			/>

			{/* <CardsModal
				isOpen={showConfirmationDialog}
				toggleHandler={toggleCombineCard}
				size="md"
			>
				<ConfirmationModal
					title="Combine Card"
					message={
						<Flex flexDirection="column" rowGap="10px">
							<span>
								Combining cards will remove this card from your
								profile. Any balance on this card will transfer
								to your default card. It will also give you 1
								extra point towards your free drinks reward.
							</span>
							<span>
								Proceed to combine card #{cardNumber} into your
								default card?
							</span>
						</Flex>
					}
					cancelHandler={toggleCombineCard}
					confirmHandler={CombineCard}
					cancelButtonText={'Back'}
					confirmButtonText={'Combine'}
					isConfirmationLoading={isCombineLoading}
				/>
			</CardsModal> */}

			<Modal
				isOpen={showSuccessDialog}
				toggleHandler={() => setSuccessDialog(!showSuccessDialog)}
				size="md"
			>
				<ConfirmationModal
					title="Combine Card Success"
					message={<span>Your card was successfully combined!</span>}
					confirmHandler={() => setSuccessDialog(!showSuccessDialog)}
					confirmButtonText={'Close'}
					showCancelButton={false}
				/>
			</Modal>

			<Modal
				isOpen={showErrorDialog}
				toggleHandler={() => setErrorDialog(!showErrorDialog)}
				size="md"
			>
				<ConfirmationModal
					title="Error"
					message={
						<span>
							There was an error with your request. Please try
							again later.
						</span>
					}
					confirmHandler={() => setErrorDialog(!showErrorDialog)}
					confirmButtonText={'Close'}
					showCancelButton={false}
				/>
			</Modal>
		</>
	);
};

export default NewCardModal;

const QRContainer = styled.div`
	background: #ffffff;
	padding: 24px 0;
	display: flex;
	justify-content: center;
`;

const Notes = styled.div`
	color: #000;
	font-size: 14px;
`;

const Text = styled.div`
	color: #000;
	font-size: 20px;
	font-weight: 500;
`;
